import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { type SystemMessage } from '../types';
import { StyledGridMessageCardContainer, StyledGridSystemEventMessageContent, StyledSpanCreatedAtDetails } from '../styles';
import Typography from '../../../Typography';
interface SystemMessageCardProps {
  message: SystemMessage;
}
const SystemMessageCard = forwardRef<HTMLDivElement, SystemMessageCardProps>((t0, ref) => {
  const $ = _c(9);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.createdAtString) {
    t1 = <Typography variant="body3"><StyledSpanCreatedAtDetails> {message.createdAtString}</StyledSpanCreatedAtDetails></Typography>;
    $[0] = message.createdAtString;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message.content || $[3] !== ref || $[4] !== t1) {
    t2 = <StyledGridSystemEventMessageContent ref={ref}>{t1}{message.content}</StyledGridSystemEventMessageContent>;
    $[2] = message.content;
    $[3] = ref;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== ref || $[7] !== t2) {
    t3 = <StyledGridMessageCardContainer ref={ref} $isSystemMessage={true}>{t2}</StyledGridMessageCardContainer>;
    $[6] = ref;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
});
export default SystemMessageCard;